import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Config from "../Config.json";
import { getArticles } from "../Fetching"; // Feltételezve, hogy van API hívás a cikkekhez


const NewsArchive = () => {
  const TITLE = `News Archive | ${Config.SITE_TITLE}`;
  const DESC = "Browse all AI-related news and articles.";
  const CANONICAL = Config.SITE_DOMAIN + "/";
  const [articles, setArticles] = useState([]);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const articlesPerPage = 10;

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const data = await getArticles(); // Lekéri az összes hírt
        setArticles(data);
        setFilteredArticles(data);
      } catch (error) {
        console.error("Hiba a hírek betöltésekor:", error);
      }
    };
    fetchArticles();
  }, []);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    filterArticles(category, searchQuery);
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    filterArticles(selectedCategory, query);
    setCurrentPage(1);
  };

  const filterArticles = (category, query) => {
    let filtered = [...articles];

    if (category !== "All") {
      filtered = filtered.filter((article) => article.category === category);
    }

    if (query) {
      filtered = filtered.filter((article) =>
        article.Title.toLowerCase().includes(query.toLowerCase())
      );
    }

    setFilteredArticles(filtered);
  };

  // Pagination
  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = filteredArticles.slice(indexOfFirstArticle, indexOfLastArticle);
  const totalPages = Math.ceil(filteredArticles.length / articlesPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <main className="news-archive">

      <Helmet>
        <title>News Archive</title>
        <meta name="description" content={DESC} />
        <link rel="canonical" href={CANONICAL} ></link>
      </Helmet>

      <div className="container">
        <h1 className="text-center my-4">News Archive</h1>

        {/* Kategória szűrés */}
        <div className="d-flex justify-content-center mb-3">
          {["All", "AI Tools", "Machine Learning", "News", "Games"].map((cat) => (
            <button
              key={cat}
              className={`btn btn-outline-primary mx-1 ${selectedCategory === cat ? "active" : ""}`}
              onClick={() => handleCategoryChange(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Keresés */}
        <div className="d-flex justify-content-center mb-4">
          <input
            type="text"
            placeholder="Search articles..."
            value={searchQuery}
            onChange={handleSearch}
            className="form-control w-50"
          />
        </div>

        {/* Hírek listázása */}
        <div className="row">
          {currentArticles.length === 0 ? (
            <p className="text-center">No articles found.</p>
          ) : (
            currentArticles.map((article) => (
              <div className="col-md-6 col-lg-4 mb-4" key={article.ArtId}>
                <div className="card h-100">
                  <img
                    src={article.img ? `/articleImages/${article.img.split("/").pop()}` : "https://via.placeholder.com/300"}
                    alt={article.Title}
                    className="card-img-top"
                  />
                  <div className="card-body">
                    <h5 className="card-title">{article.Title}</h5>
                    <p className="card-text text-truncate">{article.Teaser}</p>
                    <p className="text-muted">Published: {new Date(article.time).toLocaleDateString()}</p>
                    <a href={`/article/${article.ArtId}`} className="btn btn-primary w-100">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Lapozás */}
        {totalPages > 1 && (
          <nav className="d-flex justify-content-center my-4">
            <ul className="pagination">
              {Array.from({ length: totalPages }, (_, i) => (
                <li key={i + 1} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                  <button className="page-link" onClick={() => handlePageChange(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </main>
  );
};

export default NewsArchive;
